import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 弹出框的时候滚动条隐藏和出现导致页面抖动问题
ElementUI.Dialog.props.lockScroll.default = false;
import "./element-pink.scss";
// 子页面css
import "./static/css/x-banner.css"
Vue.prototype.openLoading = function () {
  var loading = this.$loading({
    // 声明一个loading对象
    lock: true, // 是否锁屏
    text: "正在加载...", // 加载动画的文字
    spinner: "el-icon-loading", // 引入的loading图标
    background: "rgba(0, 0, 0, 0.3)", // 背景颜色
    target: ".index", // 需要遮罩的区域
    body: true,
  });
  setTimeout(function () {
    // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close(); // 关闭遮罩层
  }, 5000);
  return loading;
};
// 分页
import Pagination from "@/components/Pagination";
Vue.component("Pagination", Pagination);
// 侧边栏

import SLIDE from "@/components/Slide";
Vue.component("SLIDE", SLIDE);
// 文章页

import ARTICLE from "@/components/Article";
Vue.component("ARTICLE", ARTICLE);
// 列表页
import LIST from "@/components/list";
Vue.component("LIST", LIST);
// 二级导航
import NAVIGATION from "@/components/navigation";
Vue.component("NAVIGATION", NAVIGATION);
// 辅助功能区
import FUNCTION from "@/components/function";
Vue.component("FUNCTION", FUNCTION);
// Vue.use(Directives);
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueCropper from "vue-cropper";
Vue.use(VueCropper);
// require styles
// import "./static/swiper.css";
Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);

import jquery from "jquery";
Vue.prototype.$ = jquery;

// 滚动
// import scroll from 'vue-seamless-scroll'
// Vue.use(scroll)

// 导入ckeditor组件
// import CKEditor from '@ckeditor/ckeditor5-vue2'
// Vue.use( CKEditor )

Vue.config.productionTip = false;


import Videojs from 'video.js';
import "video.js/dist/video-js.css";
Vue.prototype.$video = Videojs;

new Vue({
  router,
  // store,
  render: (h) => h(App),
  data: {
    Bus: new Vue(),
  },
}).$mount("#app");

router.afterEach((to, from, next) => {
  // if (!to.meta.keepAlive) {
  window, scrollTo(0, 0);
  // }
});
